import { Component, Input } from '@angular/core';
import { SmartFormContainer, TableFilter } from '@shared';

@Component({
  selector: 'app-checkbox-filter',
  templateUrl: './checkbox-filter.component.html',
  styleUrls: ['./checkbox-filter.component.scss'],
})
export class CheckboxFilterComponent extends SmartFormContainer {
  @Input() config: TableFilter;
}
